import getNumberImage from './getNumberImage'

const blankSRImage = new URL('../assets/images/bbRollNumberBlank.png', import.meta.url).href
//--------------------------
// load combatant SR images
//--------------------------
export default function loadCombatantSRImages(combatant) {
  // console.log("---------------------")
  // console.log("IN loadCombatantSRImages comb = " + combatant.name + " srroll = " + combatant.sr_roll)
  //-------------------------------
  // load sr roll image if present
  //-------------------------------
  if (combatant.sr_roll > 0) {
    // console.log("loading sr roll image")
    combatant.sr_roll_image = getNumberImage(combatant.sr_roll)
  } else {
    // console.log("loading BLANK sr image")
    //------------------------------
    // set default/blank roll image
    //------------------------------
    combatant.sr_roll_image = blankSRImage
  }
  //--------------------------------
  // load roll-off image if present
  //--------------------------------
  if (combatant.roll_off > 0) {
    combatant.roll_off_image = getNumberImage(combatant.roll_off)
  } else {
    //------------------------------
    // set default/blank roll image
    //------------------------------
    combatant.roll_off_image = blankSRImage
  }
  return combatant
}
